(function($)
{
    $( document ).ajaxError(function( event, request )
    {
        if (request.status === 403)
        {
            $('#overlay-login').removeClass('hidden');
            $('body').addClass('focus-active');
        }
    });

    $(document).ajaxSend(function(ev, jqxhr, settings)
    {
        var
            localeCode,
            languageCode,
            parser,
            whitelist = [
                'api-age-confirmation',
                'api-checkout',
                'api-cart-orderitems',
                'api-cart',
                'api-orderlist',
                'js_catalog',
                'javascript-content',
                'api-bonusitem',
                'api-shoppinglist',
                'api-newsletter',
                'api-sales-chargeback',
                'v1-api-unpaid-invoice-details',
                'api-availability-watchlist',
                'v1-api-product-downloads',
                'v1-api-complaints',
                'v1-api-media-library-search',
                'v1-api-media-library-file-download',
                'v1-api-media-library-archive-download',
                'api-product-search'
            ],
            reg = new RegExp('(/?)(' + whitelist.join('|') + ')(/|$)');

        /*
		 * @Note These assignments are only there to apease the linter. It would otherwise complain about ev and jqxhr
		 *       having been declared but not used. To remove that kind of noise from otherwise helpful lint messages,
		 *       these identity assignments should be included.
		 */

        /*
		 * UPDATE: since the new eslint-configuration, this step is no longer needed.
		 * A downside is that the linter does not check usage of method params.
		 */
        /*
		 *ev = ev;
		 *jqxhr = jqxhr;
		 */

        if (reg.test(settings.url))
        {
            localeCode = $('meta[name="localeCode"]').attr('content');
            languageCode = localeCode.substring(0, 2);
            parser = document.createElement('a');
            parser.href = settings.url;
            parser.pathname = parser.pathname.replace(reg, '$1$2-' + languageCode + '$3');
            settings.url = parser.href;
        }
    });

    var
        loadSubmenus = (function()
        {
            var loadPromise;

            return function(o)
            {
                if (!!loadPromise && !(!!o && !!o.force))
                {
                    return loadPromise;
                }

                var data = {};

                if ($('meta[name="shop_profile_code"]').length)
                {
                    data = {
                        shopProfileCode: $('meta[name="shop_profile_code"]').attr('content')
                    };
                }

                loadPromise = $.ajax({
                    'url': '/javascript-content/nav-main',
                    'data': data,
                    'method': 'GET',
                    'cache': true
                });

                return loadPromise;
            };
        })();
    /*
		 *loadAndAppendSubmenus = (function () {
		 * var submenuPromise;
		 *
		 * return function() {
		 * var
		 * $navMain,
		 * $navMainInner;
		 *
		 * if (submenuPromise) {
		 * return submenuPromise;
		 * }
		 * submenuPromise = $.Deferred();
		 *
		 * $navMain = $('#nav-main');
		 * $navMainInner = $('.inner', $navMain);
		 *
		 * loadSubmenus()
		 * .done(function (content, status, jqXhr) {
		 * //status = status;
		 *
		 * if (!/^text\/html/.test(jqXhr.getResponseHeader('Content-type'))) {
		 * submenuPromise.fail();
		 * submenuPromise = false;
		 *
		 * loadSubmenus({ force: true });
		 *
		 * return;
		 * }
		 *
		 * $navMainInner.append(content);
		 * $navMain.trigger(orion.constants.EventNavigationAppended);
		 *
		 * submenuPromise.resolve();
		 * });
		 *
		 * return submenuPromise;
		 * };
		 *})();
		 */

    function show($el)
    {
        $el.removeClass(orion.classHidden);
    }

    function showExclusive($el, $elHide)
    {
        hide($elHide);
        show($el);
    }

    function toggle($el)
    {
        $el.toggleClass(orion.classHidden);
    }

    function toggleExclusive($el, $elHide)
    {
        if ($el.hasClass(orion.classHidden))
        {
            showExclusive($el, $elHide);
        }
        else
        {
            hide($el);
        }
    }

    function hide($el)
    {
        $el.addClass(orion.classHidden);
    }

    function toTranslateStyle(x, y)
    {
        return {
            'transform': 'translate(' + x + 'px, ' + y + 'px)'
        };
    }

    function fadeIn($element)
    {
        $element.fadeIn(3000);
    }

    // starts loading indicator and counts running processes
    function startProcessing(element)
    {
        console.log('startProcessing');
        $(element).addClass('processing');
        var runningProcessCount = $(element).data('running-process-count');

        if (runningProcessCount == undefined)
        {
            runningProcessCount = 0;
        }
        runningProcessCount += 1;
        console.log('runningProcessCount: ' + runningProcessCount);
        $(element).data('running-process-count', runningProcessCount);
    }

    // counts running processes and removes loading indicator when count = 0
    function stopProcessing(element)
    {
        console.log('stopProcessing');
        var runningProcessCount = $(element).data('running-process-count');

        runningProcessCount -= 1;
        if (runningProcessCount == 0)
        {
            $(element).removeClass('processing');
        }
        console.log('runningProcessCount: ' + runningProcessCount);
        $(element).data('running-process-count', runningProcessCount);
    }

    function handleLoginRedirectParameter()
    {
        console.log('handleLoginRedirectParameter');
        var $form = $('.form-login-plain-form-redirect');

        if (!$form.length)
        {
            return;
        }
        var pathname = window.location.pathname + window.location.search + window.location.hash;
        var action = $form.attr('data-action-link');

        var redirectAction = '';

        if (pathname.indexOf('loginRedirect') !== -1)
        {
            redirectAction = action + pathname;
        }
        else if (action.indexOf('#') !== -1)
        {
            var actionParts = action.split('#');

            if (actionParts[0].indexOf('?') !== -1)
            {
                redirectAction = actionParts[0] + '&loginRedirect=' + encodeURIComponent(pathname)
					+ '#' + actionParts[1];
            }
            else
            {
                redirectAction = actionParts[0] + '?loginRedirect=' + encodeURIComponent(pathname)
					+ '#' + actionParts[1];
            }
        }
        else if (action.indexOf('?') !== -1)
        {
            redirectAction = action + '&loginRedirect=' + encodeURIComponent(pathname);
        }
        else
        {
            redirectAction = action + '?loginRedirect=' + encodeURIComponent(pathname);
        }
        $form.attr('action', redirectAction);
    }

    $.extend(orion, {
        'hide': hide,
        'show': show,
        'showExclusive': showExclusive,
        'toggle': toggle,
        'toggleExclusive': toggleExclusive,
        'toTranslateStyle': toTranslateStyle,
        'fadeIn': fadeIn,
        'startProcessing': startProcessing,
        'stopProcessing': stopProcessing,
        'handleLoginRedirectParameter': handleLoginRedirectParameter,
    });

    $(function()
    {
        $('form').attr('novalidate', true);
        $('html').addClass('js')
            .removeClass('no-js');
        $('iframe').iFrameResize();

        if ('ontouchstart' in document.documentElement)
        {
            $('html').addClass('touch');
        }

        loadSubmenus();

        if (!window.Cookies.enabled)
        {
            $('html').addClass('no-cookies');
        }

        function jumpToFirst($input)
        {
            var
                $htmlBody = $('html, body'),
                $offsetElement = $('#logo'),
                offset = 60 + ((0 === $offsetElement.length) ? 0 : $offsetElement.outerHeight(true));

            $htmlBody.animate({
                'scrollTop': $input.offset().top - offset
            }, '500', 'swing');
        }

        function handleValidationFailedOnSubmit(e, data)
        {
            // e = e;
            jumpToFirst(data.$inputsFailed);
        }

        function handleBlurYear()
        {
            var
                $this = $(this),
                numericYear = parseInt($this.val()),
                currentYear = new Date().getFullYear(),
                currentYearShort = currentYear % 100;

            if (isNaN(numericYear))
            {
                return;
            }

            if (numericYear > 99)
            {
                return;
            }

            if (numericYear <= currentYearShort)
            {
                $this.val(numericYear + currentYear - currentYearShort);
                $this.trigger('input');
                return;
            }

            $this.val(numericYear + currentYear - currentYearShort - 100);
            $this.trigger('input');
        }

        function handleOnsiteBasketUpdate()
        {
            if ($('#basket-onsite').data('cart-quantity') == 0)
            {
                $('.js-basket-onsite-empty').removeClass('hidden');
                $('.js-basket-onsite-not-empty').addClass('hidden');
            }
            else if ($('#basket-onsite').data('cart-quantity') != 0)
            {
                $('.js-basket-onsite-empty').addClass('hidden');
                $('.js-basket-onsite-not-empty').removeClass('hidden');
            }
        }

        $('input[data-date-role=year]').on('change', handleBlurYear);
        $('form').on(orion.constants.EventValidationFailedOnSubmit, handleValidationFailedOnSubmit);
        $('#basket-onsite').on('basketUpdate', handleOnsiteBasketUpdate);

        $(document).on('click', function(e)
        {
            console.log('global.js click');
            if ($(e.target).is('.overlay.focus'))
            {
                $('body').trigger(orion.constants.EventFocusOverlayClicked);
                document.querySelector('body').dispatchEvent(new Event(orion.constants.EventFocusOverlayClicked));
            }
        });
    });
})(jQuery);

$(document).ready(function()
{
    orion.handleLoginRedirectParameter();
});
